<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-admin-manufacturerCreate"
    >
      <h2 class="o-heading o-heading--size-2 o-heading--border" slot="header">
        {{
          mutableObject.id === 0
            ? translationsManufacturersModal.createHeadline
            : `${translationsManufacturersTable.editManufacturer} "${
                mutableObject.name
              }"`
        }}
      </h2>
      <div slot="body">
        <div
          class="c-admin-manufacturerCreate__inputs-wrap o-grid o-grid--gutter-normal o-grid--padding-none o-grid--align-items-center"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsManufacturersModal.manufacturerName || "" }}
              </h4>
              <input
                class="o-input o-input--modal"
                type="text"
                maxlength="255"
                v-model="mutableObject.name"
                :placeholder="translationsCustom.addValue || ''"
              />
              <div class="o-label o-label--help-text">
                {{ translationsManufacturersModal.manufacturerNameHelp || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="o-button"
                v-if="mutableObject.id === 0"
                :disabled="mutableObject.name === ''"
                @click="create"
              >
                {{ translationsManufacturersTable.addManufacturer }}
              </button>
              <button
                class="o-button"
                v-else
                :disabled="mutableObject.name === ''"
                @click="edit"
              >
                {{ translationsManufacturersTable.editManufacturer }}
              </button>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="o-button o-button--transparent"
                @click="closeModal()"
              >
                {{ translationsCustom.cancel || "" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      name: "Angiv status",
      showModal: false,
      mutableObject: {
        id: 0, // BE needs it to be 0 and not NULL
        name: ""
      }
    };
  },
  props: {
    manufacturer: { type: Object, required: false },
    showManufacturerCreate: { type: Boolean, required: true }
  },
  computed: {
    ...mapState("manufacturers", ["selectableOptions"]),
    ...mapState("translations", {
      translationsManufacturersModal: "manufacturersModal",
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    })
  },
  methods: {
    ...mapActions("manufacturers", ["addManufacturer", "editManufacturer"]),
    closeModal() {
      this.mutableObject = {
        id: 0, // BE needs it to be 0 and not NULL
        name: ""
      };
      this.showModal = false;
      this.$emit("close");
    },
    create() {
      this.addManufacturer(this.mutableObject);
      this.closeModal();
    },
    edit() {
      this.editManufacturer(this.mutableObject);
      this.closeModal();
    }
  },
  watch: {
    showManufacturerCreate(newValue) {
      this.showModal = newValue;
    }
  },
  created() {
    if (this.manufacturer) {
      this.mutableObject = this.manufacturer;
    }
    this.$nextTick(() => {
      this.showModal = this.showManufacturerCreate;
    });
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if (mutation.type === "manufacturers/setEditManufacturer") {
        this.mutableObject = JSON.parse(JSON.stringify(mutation.payload));
        this.showModal = true;
      }
    });
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-admin-manufacturerCreate {
}
</style>
